import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import API from '../services/api';
import { toast } from 'react-toastify';

// Components
import Loading from './components/Loading';
import JustifieContainer from './Justifies/justifieContainer';
import history from '../services/history';

// Images
import iconOperacional from '../img/icons/title-ope.png';
import iconUser from '../img/user-header.png';
import iconRemetente from '../img/icons/icon-nf-remetente.png';
import iconMap from '../img/icons/icon-nf-map.png';
import iconBarco from '../img/icons/icon-barco.png';
import iconAir from '../img/icons/icon-air.png';
import iconBack from '../img/icons/back.png';
import checkNot from '../img/icons/check-not.png';
import checkOk from '../img/icons/check-ok.png';
import checkNull from '../img/icons/check-null.png';
import {MdReportProblem} from 'react-icons/md'
import Maps from './components/Maps';
import { de } from 'date-fns/locale';
// Components

class DetalheOperacional extends Component {
  state = {
    deop: [],
    isLoading: false,
    uuid: null,
    locationReferences: [],
  };

  async componentDidMount() {
    this.getPoItem();
  }

  getPoItem = async () => {
    this.setState({
      isLoading: true,
    });
    const { uuid } = this.props.match.params;
    const res = await API.get(`poItems/${uuid}`);
    const deop = res.data;
    console.log(deop);
    this.setState({
      deop,
      isLoading: false,
      uuid,
    });
    if (deop.process_critical && deop.process_critical === 'YES'){
      this.notifyError("PO em processo crítico!")
    }
  };

  notifyError = msg => {
    toast.error(msg, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  verifyChannel = () => {
    const { deop } = this.state;
    let colorChannel = '';
    if ((deop.channel != 'Green') && !deop.gr_effective
      && deop.dt_registro_duimp) {
      colorChannel = deop.channel;

      if (colorChannel == 'Red') {
        colorChannel = <p id='red'>Canal Vermelho</p>;

      } else if (colorChannel == 'Yellow') {
        colorChannel = <p id='yellow'>Canal Amarelo</p>;

      }
    }
    return colorChannel;

  }

  //Já esta trazendo os dados do backend

  // calculateStorageLimitDate = () => {
  //   const { deop } = this.state;
  //   if (!deop.ata_date) return null;
  //   const ataDate = new Date(deop.ata_date);
  //   const limitDate = new Date(ataDate);
  //   limitDate.setDate(limitDate.getDate() + 12);
  //   return limitDate;
  // }

  // calculateStorageStatus = () => {
  //   const limitDate = this.calculateStorageLimitDate();
  //   if (!limitDate) return '-';
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);
  //   limitDate.setHours(0, 0, 0, 0);
  //   // No Prazo se a data limite é hoje ou no futuro, Vencida se está no passado
  //   return limitDate >= today ? 'No Prazo' : 'Vencida';
  // }

  render() {
    const { deop, uuid } = this.state;
    // const storageLimitDate = this.calculateStorageLimitDate();
    // const storageStatus = this.calculateStorageStatus();
    return (
      <div>
        <div className="center" >
          <div className="page-header" >
            <h1>
              <img src={iconOperacional} alt="" />
              Operacional
            </h1>
            <div className="last-wrap">

              <div className="btnvoltar" onClick={() => history.goBack()}>
                <img src={iconBack} alt="" />
                <p>Voltar</p>
              </div>

            </div>
          </div>
          {this.state.isLoading ? (
            <Loading />
          ) : (
            <div className="content-regerencial">
              <div className="page-interna">
                <header
                  className={
                    deop.process_critical === 'YES' ? 'title yes' : 'title'
                  }
                >
                  <div className="first">
                    <p>
                      PO:
                      <strong>
                        {' '}
                        {deop.po
                          ? `${deop.po.order_reference} - ${deop.item}`
                          : ''}{' '}
                      </strong>
                    </p>
                    <p>
                      Produto:{' '}
                      <strong>
                        {deop.po ? deop.po.product.product_description : ''}
                      </strong>
                    </p>
                  </div>
                  <div className="last">
                    <p className="emp">Qtd: {deop.qty}</p>
                  </div>
                </header>

                <div className="list-po">
                  <div className="content-po ">
                    <header>
                      <div className="gra">
                        <p>Modal:</p>
                        <p>{deop.modal}</p>
                      </div>
                      <div className="historico">
                        <div className="hist-tit">
                          <p>Último Histórico</p>
                          <p className="date">
                            {deop.last_update
                              ? new Date(deop.last_update).toLocaleDateString()
                              : '-'}
                          </p>
                        </div>
                        <div className="boll">
                          <span />
                        </div>
                        <div className="infouser">
                          <img src={iconUser} alt="" />
                          <div className="info">
                            <p>{deop.last_historic}</p>
                          </div>
                        </div>
                      </div>
                    </header>
                    <div className="boxs">
                      <div className="box">
                        <div className="icon">
                          <img src={iconRemetente} alt="" />
                          <p>Remetente</p>
                        </div>
                        <div className="info">
                          <div className="row">
                            <p>Razão Social:</p>
                            <p>{deop.shipper}</p>
                          </div>
                          <div className="row">
                            <p>Origem:</p>
                            <p>{deop.shipper_address}</p>
                          </div>
                        </div>
                      </div>
                      <div className="box">
                        <div className="icon">
                          <img src={iconMap} alt="" />
                          <p>Destinatário</p>
                        </div>
                        <div className="info">
                          <div className="row">
                            <p>Razão Social:</p>
                            <p>{deop.po ? deop.po.product.consignee : ''}</p>
                          </div>
                          <div className="row">
                            <p>Porto Destino:</p>
                            <p>{deop.destination}</p>
                          </div>
                          <div className="row">
                            <p>Planta Destino:</p>
                            <p>
                              {deop.plant_destiny === '47.180.625/0021-90'
                                ? 'CTVA - FR. ROCHA'
                                : deop.plant_destiny === '47.180.625/0019-75'
                                ? 'CTVA - MOGI MIRIM'
                                : deop.plant_destiny === '47.180.625/0020-09'
                                ? 'CTVA - JACAREI'
                                : deop.plant_destiny === '47.180.625/0022-70'
                                ? 'CTVA - IBIPORA'
                                : deop.plant_destiny === '61.064.929/0001-79'
                                ? 'CORTEVA - BARUERI'
                                : deop.plant_destiny === '61.064.929/0072-62'
                                ? 'CORTEVA - IBIPORA'
                                : deop.plant_destiny === '61.064.929/0076-96'
                                ? 'CORTEVA - PAULINIA'
                                : '-'}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="box">
                        <div className="icon">
                          <img
                            src={
                              deop.modal === 'Ocean Import'
                                ? iconBarco
                                : iconAir
                            }
                            alt=""
                          />
                          <p>Previsões</p>
                        </div>
                        <div className="info">
                          <div className="row">
                            <p>ETD:</p>
                            <p>
                              {new Date(deop.etd_date).toLocaleDateString()}
                            </p>
                          </div>
                          <div className="row">
                            <p>ETA:</p>
                            <p>
                              {new Date(deop.eta_date).toLocaleDateString()}
                            </p>
                          </div>
                          <div className="row">
                            <p>GR Atual</p>
                            <p>
                              {new Date(deop.gr_actual).toLocaleDateString()}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      deop.alerts && deop.alerts[0] ?
                      (
                        <div className='boxs'>
                          <div className='box-alerts'>
                            <div className='icon'>
                              <div>
                                <MdReportProblem margin='10px' theme='outline' color='red' size='20px'/>
                              </div>
                              <p>Ultimos alertas</p>
                            </div>
                            {deop.alerts.map((e,i)=>{
                              return(
                                <p key={i} className='tit'><span>{i+1} - </span>{e.message}</p>
                              )
                            })}
                          </div>
                        </div>
                      ) : ''
                    }
                    <div className="boxs">
                      <div className="box">
                        <div className="icon">
                          <img src={iconBarco} alt="" />
                          <p>INFORMAÇÕES DE TRANSPORTE</p>
                        </div>
                        <div className="info">
                          <div className="row">
                            <p>Numero do Container:</p>
                            <p>{deop.containers || '-'}</p>
                          </div>
                          <div className="row">
                            <p>Tipo do Container:</p>
                            <p>{deop.container_type || '-'}</p>
                          </div>
                          <div className="row">
                            <p>Agente de Carga:</p>
                            <p>{deop.carrier || '-'}</p>
                          </div>
                          <div className="row">
                            <p>Navio:</p>
                            <p>{deop.vessel || '-'}</p>
                          </div>
                        </div>
                      </div>
                      <div className="box">
                        <div className="icon">
                          <img src={iconBarco} alt="" />
                          <p>INFORMAÇÕES DE DEMURRAGE</p>
                        </div>
                        <div className="info">
                          <div className="row">
                            <p>Free Time:</p>
                            <p>
                              {deop?.demurrage_info
                                ? deop.demurrage_info?.free_time
                                : '-'}
                            </p>
                          </div>
                          <div className="row">
                            <p>Data Limite:</p>
                            <p>
                              {deop?.demurrage_info
                                ? deop?.demurrage_info?.dt_limite_demurrage
                                : '-'}
                            </p>
                          </div>
                          <div className="row">
                            <p>Status:</p>
                            <p>
                              {deop?.demurrage_info
                                ? deop?.demurrage_info?.dt_demurrage_status
                                : '-'}
                              </p>
                          </div>
                        </div>
                      </div>
                      <div className="box">
                        <div className="icon">
                          <img src={iconMap} alt="" />
                          <p>INFORMAÇÕES DE ARMAZENAMENTO</p>
                        </div>
                        <div className="info">
                          <div className="row">
                            <p>Prazo:</p>
                            <p>
                              {deop?.storage_info
                                ? deop?.storage_info?.storage_days
                                : '-'}
                            </p>
                          </div>
                          <div className="row">
                            <p>Data Limite:</p>
                            <p>
                              {deop?.storage_info
                                ? deop?.storage_info?.storage_limit_date
                                : '-'}
                            </p>
                          </div>
                          <div className="row">
                            <p>Status:</p>
                            <p>
                              {deop?.storage_info
                                ? deop?.storage_info?.storage_status
                                : '-'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="box-transportadora">
                      <div className="line-status">
                        <div className="date-leg">
                          <p>
                            {deop.booking_confirmation_date
                              ? new Date(
                                  deop.booking_confirmation_date
                                ).toLocaleDateString()
                              : ' '}
                          </p>
                          <p>
                            {deop.atd_date
                              ? new Date(deop.atd_date).toLocaleDateString()
                              : ''}
                          </p>
                          <p>
                            {deop.ata_date
                              ? new Date(deop.ata_date).toLocaleDateString()
                              : ''}
                          </p>
                          <p>
                            {deop.port_entry_date
                              ? new Date(
                                  deop.port_entry_date
                                ).toLocaleDateString()
                              : '-'}
                          </p>
                          <p>
                            {deop.dt_registro_duimp
                              ? new Date(
                                  deop.dt_registro_duimp
                                ).toLocaleDateString()
                              : ' '}
                          </p>
                          <p>
                            {deop.nf_date
                              ? new Date(deop.nf_date).toLocaleDateString()
                              : ' '}
                          </p>
                          <p>
                            {deop.loading_at_the_terminal
                              ? new Date(
                                  deop.loading_at_the_terminal
                                ).toLocaleDateString()
                              : ' '}
                          </p>
                          <p>
                            {deop.plant_delivery
                              ? new Date(
                                  deop.plant_delivery
                                ).toLocaleDateString()
                              : ' '}
                          </p>
                          <p>
                            {deop.gr_effective
                              ? new Date(deop.gr_effective).toLocaleDateString()
                              : ' '}
                          </p>
                        </div>
                        <div className="position">
                          {deop.timeline
                            ? deop.timeline.map(posit => (
                                <div
                                  className={` ${
                                    posit.actual ? 'boll atual' : 'boll'
                                  } ${posit.red ? 'not' : ''} `}
                                  key={posit.step}
                                >
                                  <span />
                                </div>
                              ))
                            : null}
                        </div>
                        <div className="legenda">
                          <p>Confirmação Booking</p>
                          <p>ATD</p>
                          <p>ATA</p>
                          <p>Porty Entry</p>
                          <p>Registro DUIMP</p>
                          <p>NF</p>
                          <p>
                            Transito
                            <br />
                            (Loading terminal)
                          </p>
                          <p>chegada planta</p>
                          <p>GR efetivo</p>
                        </div>
                        <div className='legendaChannel'>{this.verifyChannel()}</div>
                      </div>
                      <div className="aguardando">
                        <div
                          className={` ${
                            deop.docs_received_date_alert ? 'it not' : 'it ok'
                          }`}
                        >
                          <img
                            src={` ${
                              !deop.docs_received_date
                                ? checkNull
                                : deop.docs_received_date_alert
                                ? checkNot
                                : checkOk
                            }`}
                            alt=""
                          />
                          <span>
                            <p>Aguardando DOCS</p>
                            <p>
                              {deop.docs_received_date
                                ? new Date(
                                    deop.docs_received_date
                                  ).toLocaleDateString()
                                : '-'}
                            </p>
                          </span>
                        </div>
                        {deop.released_wood && (
                          <div className="it ok madeira-liberada">
                            <span>
                              <p>Madeira Liberada</p>
                              <p>
                                {new Date(
                                  deop.released_wood
                                ).toLocaleDateString()}
                              </p>
                            </span>
                          </div>
                        )}
                        {/* <div
                        className={` ${
                          deop.protocol_mapa_in26_date_alert
                            ? 'it not'
                            : 'it ok'
                        }`}
                      >
                        <img
                          src={` ${
                            !deop.protocol_mapa_in26_date
                              ? checkNull
                              : deop.protocol_mapa_in26_date_alert
                              ? checkNot
                              : checkOk
                          }`}
                          alt=""
                        />
                        <span>
                          <p>Aguardando Protocolo LI</p>
                          <p>
                            {deop.protocol_mapa_in26_date
                              ? new Date(
                                  deop.protocol_mapa_in26_date
                                ).toLocaleDateString()
                              : '-'}
                          </p>
                        </span>
                      </div>
                      <div
                        className={` ${
                          deop.post_import_license_release_date_alert
                            ? 'it not'
                            : 'it ok'
                        }`}
                      >
                        <img
                          src={` ${
                            !deop.post_import_license_release_date
                              ? checkNull
                              : deop.post_import_license_release_date_alert
                              ? checkNot
                              : checkOk
                          }`}
                          alt=""
                        />
                        <span>
                          <p>Aguardando Defrimento LI</p>
                          <p>
                            {deop.post_import_license_release_date
                              ? new Date(
                                  deop.post_import_license_release_date
                                ).toLocaleDateString()
                              : '-'}
                          </p>
                        </span>
                      </div> */}
                      </div>
                      </div>

                      <div className="box-transportadora box-operacional-mapa">
                        <div className="header-mapa">
                          <div className="icon">
                                <img src={iconMap} alt="" />
                            <div className='title-mapa-container'>
                              Mapa <span className="header-line"></span>
                            </div>
                          </div>
                        </div>
                        <Maps dataPoItem={deop} />
                      </div>

                  </div>
                </div>
                <JustifieContainer
                  uuid={uuid}
                  deop={deop}
                  getPoItem={this.getPoItem}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default DetalheOperacional;
